import { businessDaysSince as bdSince } from './businessDays';

// Hoeveel dagen geleden was dit? Een datum in de TOEKOMST levert een negatief
// getal op, en dat is geen datafout: taken (geplande huisbezoeken) en
// afspraken staan met opzet vooruit. Wat wél fout is, is dat getal aan de
// lezer tonen als 'dagen geleden' — '-2 dagen geleden' bestaat niet.
//
// Gebruik daarom nooit `${daysSince(x)}d` rechtstreeks in de UI. `formatDayAge`
// maakt er 'over 2d' van en `daysColorClass` geeft de toekomst een eigen kleur,
// want groen betekent 'recent gebeurd' en dat is iets anders dan 'staat
// gepland'. Hetzelfde geldt voor `businessDaysSince`, dat ook negatief telt.
const daysSince = (timestamp) => {
  if (!timestamp?.toDate) return null;
  const ms = Date.now() - timestamp.toDate().getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24));
};

const businessDaysSince = bdSince;

/**
 * Korte weergave van een dag-afstand: '5d' voor het verleden, 'over 2d' voor
 * de toekomst. Single source of truth — elke plek die een dag-afstand toont
 * hoort hierlangs te gaan, anders komt het minteken toch weer op het scherm.
 *
 * @param {number | null | undefined} days - uitkomst van daysSince of businessDaysSince
 * @param {string} [suffix] - eenheid achter het getal, bijvoorbeeld 'd', 'wd' of ' wd'
 * @returns {string | null} null als er geen aantal is
 */
const formatDayAge = (days, suffix = 'd') => {
  if (days === null || days === undefined) return null;
  return days < 0 ? `over ${Math.abs(days)}${suffix}` : `${days}${suffix}`;
};

const daysColor = (days) => {
  if (days < 0) return "future";
  if (days < 30) return "green";
  if (days < 90) return "orange";
  return "red";
};

// CSS class voor de leeftijd-kleur. Single source of truth — wijzig hier
// om de kleur-grenzen aan te passen, dan past UI overal mee aan.
const daysColorClass = (days) => {
  if (days === null || days === undefined) return "";
  // Nog niet gebeurd is niet hetzelfde als net gebeurd: zonder deze tak valt
  // een geplande taak in de groene 'vers'-tak en leest hij als activiteit.
  if (days < 0) return "days-age days-age--future";
  if (days < 30) return "days-age days-age--green";
  if (days < 90) return "days-age days-age--orange";
  return "days-age days-age--red";
};

export { daysSince, businessDaysSince, daysColor, daysColorClass, formatDayAge };
